import React from 'react';
import PropTypes from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress';
import {connect} from 'react-redux';
import {filterWhatsappTemplates, createWhatsappTemplate, updateWhatsappTemplate} from '../../../actions/whatsappTemplates';
import EnhancedTable from '../../common/enhancedTable';
import {whatsappTemplatesCols} from '../../../utils/colTypes';
import CustomSnackbar from '../../common/customSnackbar';
import WhatsappTemplateDetail from './detail';
import {SUPER_ADMIN_ROL_ID} from '../../../utils/utils';
import {getCompanies} from '../../../actions/companies';

export class WhatsappTemplates extends React.Component {
  constructor(props) {
    super(props);
    this.state = {           
      whatsappTemplate: null,
      isNew: false,
      title: 'Mensajes de WhatsApp'
    };
    this.onAdd = this.onAdd.bind(this);
    this.onSearch = this.onSearch.bind(this);
    this.onOrder = this.onOrder.bind(this);
    this.onDetail = this.onDetail.bind(this);
    this.handleGoBack = this.handleGoBack.bind(this);
    this.handleUpdateWhatsappTemplate = this.handleUpdateWhatsappTemplate.bind(this);
    this.handleChangePage = this.handleChangePage.bind(this);
    this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);
    this.renderSnackBar = this.renderSnackBar.bind(this);
    this.getEditPermissions = this.getEditPermissions.bind(this);
    this.getCreatePermission = this.getCreatePermission.bind(this);
  }

  componentWillMount() {
    this.getViewPermission();
    this.props.getCompanies();
    this.props.filterWhatsappTemplates(
      this.props.page, 
      this.props.rowsPerPage, 
      this.props.order, 
      this.props.orderBy, 
      this.props.searchText
    );
  }

  onAdd() {
    this.setState({isNew: true, whatsappTemplate: {}});
  }

  onOrder(order, orderBy) {
    this.props.filterWhatsappTemplates(this.props.page, this.props.rowsPerPage, order, orderBy, this.props.searchText);
  }

  onSearch(searchText) {
    this.props.filterWhatsappTemplates(this.props.page, this.props.rowsPerPage, this.props.order, this.props.orderBy, searchText);
  }

  onDetail(id) {
    const whatsappTemplate = this.props.whatsappTemplates.filter(obj => obj.id === id)[0];
    this.setState({whatsappTemplate, isNew: false});
  }

  getViewPermission = () => {
    const profile = JSON.parse(localStorage.getItem('profile'));
    if (profile) {
      if (profile.permissions.view_whatsapp_templates) {
        return true;
      }
    }
    window.location.href = '/';
    return false;
  }

  getEditPermissions = () => {
    const profile = JSON.parse(localStorage.getItem('profile'));
    if (profile) {
      if (profile.permissions.update_whatsapp_templates) {
        return true;
      }
    }
    return false;
  }

  getCreatePermission = () => {
    const profile = JSON.parse(localStorage.getItem('profile'));
    if (profile) {
      if (profile.permissions.create_whatsapp_templates) {
        return true;
      }
    }
    return false;
  }

  formatColsFromUser = (cols) => {
    const profileId = localStorage.getItem('profileId');
    let newCols = cols;
    if (SUPER_ADMIN_ROL_ID !== profileId) {
      newCols = cols.filter(col => col.id !== 'companyName');
    }
    return newCols;
  };

  handleChangeRowsPerPage(rowsPerPage) {
    this.props.filterWhatsappTemplates(this.props.page, rowsPerPage, this.props.order, this.props.orderBy, this.props.searchText);
  }

  handleChangePage(page) {
    this.props.filterWhatsappTemplates(page, this.props.rowsPerPage, this.props.order, this.props.orderBy, this.props.searchText);
  }

  handleGoBack() {
    this.props.filterWhatsappTemplates(this.props.page, this.props.rowsPerPage, this.props.order, this.props.orderBy, this.props.searchText);
    this.setState({whatsappTemplate: null, isNew: false});
  }

  handleUpdateWhatsappTemplate(whatsappTemplateEdited) {
    const {whatsappTemplate} = this.state;
    this.setState({whatsappTemplate: {...whatsappTemplateEdited, companyId: whatsappTemplateEdited.company}});
    const edited = {};
    if (whatsappTemplate.active !== whatsappTemplateEdited.active) {
      edited.active = whatsappTemplateEdited.active;
    }
    if (whatsappTemplate.template !== whatsappTemplateEdited.template) {
      edited.template = whatsappTemplateEdited.template;
    }
    if (whatsappTemplate.name !== whatsappTemplateEdited.name) {
      edited.name = whatsappTemplateEdited.name;
    }
    if (whatsappTemplate.companyId !== whatsappTemplateEdited.company) {
      edited.company = whatsappTemplateEdited.company;
    }
    this.props.updateWhatsappTemplate(whatsappTemplateEdited.id, edited);
  }

  renderSnackBar() {
    const {error, message} = this.props;
    if (message) {
      return (
        <CustomSnackbar
          variant={error !== null ? 'error' : 'success'}
          message={message}
        />
      );
    }
    return null;
  }

  render() {
    const {isLoading, whatsappTemplates, dataLength, companies} = this.props;
    const {title, whatsappTemplate, isNew} = this.state;
    const hasEditPermission = this.getEditPermissions();
    const hasCreatePermission = this.getCreatePermission();
    const data = {
      rows: whatsappTemplates,
      cols: this.formatColsFromUser(whatsappTemplatesCols)
    };
    const handlers = {
      onDetail: this.onDetail,
      onAdd: this.onAdd,
      onSearch: this.onSearch,
      onOrder: this.onOrder,
      onChangePage: this.handleChangePage,
      onChangeRowsPerPage: this.handleChangeRowsPerPage
    };
    const config = {
      isDragable: false,
      hasEditPermission,
      hasCreatePermission,
      isSelectable: false,
      isFiterable: false,
      searchText: this.props.searchText,
      order: {
        by: this.props.orderBy,
        direction: this.props.order
      },
      pagination: {
        current: this.props.page,
        rowsPerPage: this.props.rowsPerPage,
        totalItems: dataLength
      },
      filters: {
        is: false
      }
    };
    if (isLoading === true) {
      return (
        <CircularProgress style={{position: 'fixed', top: 0, bottom: 0, left: 0, right: 0, margin: 'auto'}} />
      );
    }
    return (
      <div>
        {this.renderSnackBar()}
        {
          whatsappTemplate === null ?
            <EnhancedTable 
              title={title}
              data={data}
              handlers={handlers}
              config={config}
            />  
            :
            <WhatsappTemplateDetail 
              whatsappTemplate={whatsappTemplate}
              handleGoBack={this.handleGoBack}
              handleCreateWhatsappTemplate={this.props.createWhatsappTemplate}
              handleUpdateWhatsappTemplate={this.handleUpdateWhatsappTemplate}
              isLoading={isLoading}
              isNew={isNew}
              companies={companies}
            />
        }
      </div>
    );
  }
}

WhatsappTemplates.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  whatsappTemplates: PropTypes.array.isRequired,
  filterWhatsappTemplates: PropTypes.func.isRequired,
  createWhatsappTemplate: PropTypes.func.isRequired,
  updateWhatsappTemplate: PropTypes.func.isRequired,
  message: PropTypes.string.isRequired,
  searchText: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  order: PropTypes.string.isRequired,
  dataLength: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  error: PropTypes.object,
  getCompanies: PropTypes.func.isRequired,
  companies: PropTypes.array.isRequired
};

const mapStateToProps = (state) => {
  const {whatsappTemplates, companies} = state;
  return { 
    isLoading: whatsappTemplates.sending, 
    whatsappTemplates: whatsappTemplates.whatsappTemplates,
    dataLength: whatsappTemplates.dataLength, 
    error: whatsappTemplates.error,
    message: whatsappTemplates.message,
    searchText: whatsappTemplates.searchText,
    order: whatsappTemplates.order,
    orderBy: whatsappTemplates.orderBy,
    page: whatsappTemplates.page,
    rowsPerPage: whatsappTemplates.rowsPerPage,
    filters: whatsappTemplates.filters,
    companies: companies.companies
  };
};
  
const mapDispatchToProps = {
  filterWhatsappTemplates,
  createWhatsappTemplate,
  updateWhatsappTemplate,
  getCompanies
};
  
export default connect(mapStateToProps, mapDispatchToProps)(WhatsappTemplates);
